import { DateTime } from 'luxon';
import type { OrganisationJson } from '@/api/model/Organisation';
import { Organisation } from '@/api/model/Organisation';
import type XeroConnection from '@/api/model/XeroConnection';

export interface UserJson {
    id: number;
    email: string;
    name: string;
    profile_picture: string;
    created_at: string;
    updated_at: string;
    email_verified_at: string;
    organisations: OrganisationJson[];
    xero_connections: XeroConnection[];
    roles: string[];
    is_super_admin: boolean;
}

export class User {
    id = 0;
    email = 'Unknown';
    name = 'Unknown';
    profile_picture = 'Unknown';
    created_at: DateTime = DateTime.now();
    updated_at: DateTime = DateTime.now();
    email_verified_at: DateTime = DateTime.now();
    organisations: Organisation[] = [];
    xero_connections: XeroConnection[] = [];
    roles: string[] = [];
    is_super_admin = false;

    static fromJSON(json: UserJson): User {
        //console.debug("User.fromJSON()", json);
        const user = Object.create(User.prototype);
        return Object.assign(user, json, {
            created_at: json.created_at ? DateTime.fromISO(json.created_at) : DateTime.now(),
            updated_at: json.updated_at ? DateTime.fromISO(json.updated_at) : DateTime.now(),
            email_verified_at: json.email_verified_at ? DateTime.fromISO(json.email_verified_at) : null,
            organisations: json.organisations?.map((org: OrganisationJson) => Organisation.fromJSON(org)),
            xero_connections: json.xero_connections ?? [],
            roles: json.roles ?? [],
            is_super_admin: json.is_super_admin ?? false,
        });
    }

    static mock({ name = 'Test User', email = 'test@example.com', ...overrides }: Partial<User> = {}): User {
        return Object.assign(
            new User(),
            {
                id: 1,
                name,
                email,
                profile_picture: '',
                created_at: DateTime.now(),
                updated_at: DateTime.now(),
                email_verified_at: null,
                organisations: [],
                xero_connections: [],
            },
            overrides,
        );
    }
}
